import { Component } from '@angular/core';
import { MaintenanceAnnouncement } from '@app/core/types/maintenance/maintenance.types';
import { formatAsBrusselsTime } from '@app/shared/utils/time.functions';

@Component({
    selector: 'c-maintenance-modal',
    templateUrl: './maintenance-modal.component.html',
    styleUrls: ['./maintenance-modal.component.scss'],
    standalone: false
})
export class MaintenanceModalComponent {
  maintenance: MaintenanceAnnouncement;
  minutes: number;
  close: () => void;

  get end(): string {
    return formatAsBrusselsTime(this.maintenance.end);
  }
}
